/**
 * Injects theme-matching styles directly into the Shopify Forms app embed's
 * open shadow root. Regular stylesheets cannot reach inside a shadow root,
 * so this is the only way to restyle its internals.
 *
 * Unsupported: targets the embed's DOM shape as observed at the time of
 * writing. Prefers stable hooks (tag names, data-testid) over the
 * auto-generated CSS-module classnames (e.g. "_textArea_17mgw_1"), which
 * are an implementation detail and may be renamed on any Shopify Forms
 * release without notice. Re-check after app updates if styling stops
 * applying.
 */
const STYLE_ID = 'theme-shopify-forms-overrides';
const WATCHDOG_TIMEOUT_MS = 8000;

const css = `
  ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
    max-width: 100% !important;
  }

  form._formFieldset_cit2d_82 {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
  }

  ._formFieldContainer_1mxsl_5:nth-of-type(2) {
     grid-column: 1 / -1 !important;
  }
`;

function injectInto(shadowRoot) {
  if (shadowRoot.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = css;
  shadowRoot.appendChild(style);
}

function watch(host) {
  if (!host.shadowRoot || host.dataset.themeStyleWatched) return;
  host.dataset.themeStyleWatched = 'true';

  let injected = false;
  const observer = new MutationObserver(tryInject);

  function tryInject() {
    if (host.shadowRoot.querySelector('[data-testid="form"]')) {
      injectInto(host.shadowRoot);
      injected = true;
      observer.disconnect();
    }
  }

  tryInject();
  if (!injected) {
    observer.observe(host.shadowRoot, { childList: true, subtree: true });
    setTimeout(() => {
      if (!injected) {
        observer.disconnect();
        console.warn(
          '[shopify-forms-embed-style] Gave up waiting for the form to render inside <shopify-forms-embed>. ' +
            'The embed\'s DOM shape may have changed — inspect its shadow root and update assets/shopify-forms-embed-style.js.'
        );
      }
    }, WATCHDOG_TIMEOUT_MS);
  }
}

function init() {
  document.querySelectorAll('shopify-forms-embed').forEach(watch);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
